import script from "./NavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=3cc3e4ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc3e4ff"]])

export default __exports__